






























































































































































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import {
  Action,
  Getter,
  Mutation,
} from 'vuex-class';
import {DataSet, DeviceType, DeviceVersion, Interface, Project, Site} from '@/types';

import ProjectService from '@/services/project.service';
import SiteService from '@/services/site.service';
import DeviceTypeService from '@/services/devicetype.service';
import DataSetService from '@/services/dataset.service';
import interfaceService from '@/services/interface.service';

@Component({
  components: {
  },
})
export default class ManageDataSetDetails extends Vue {
  @Getter private getDataSetById: any;
  @Getter private login: any;
  @Action private returnDataSetAsync: any;
  @Getter private hasPermission: any;

  private useInterfaces: boolean = true;

  private tab: any = null;
  private items: any[] = [
    {tab: 'projects', type: 'projects'},
    {tab: 'sites', type: 'sites'},
    {tab: 'device types', type: 'deviceTypes'},
    {tab: 'interfaces', type: 'interfaces'},
    // {tab: 'sensing metrics', type: 'sensingMetrics'},
  ];
  private dataSet: DataSet = {name: '', filters: '', streaming: false, publishing: false, query: false, owner: ''};

  private selections: any = { projects: [], sites: [], deviceTypes: [], interfaces: [] };
  private selectedFilters: number[] = [];
  private selectedAll: any = { projects: 1, sites: 1, deviceTypes: 1, interfaces: 1 };
  private tabContents: any = { projects: [], sites: [], deviceTypes: [], interfaces: [] };

  private projects: any[] = [];
  private sites: Site[] = [];
  private deviceTypes: DeviceVersion[] = [];
  private interfaces: Interface[] = [];

  private selectedEmpty: any = { projects: true, sites: true, deviceTypes: true, interfaces: true };
  private isSystem: boolean = false;
  private search: string = '';
  private searchItem: any[] = [];

  private async mounted() {
    this.deviceTypes = await DeviceTypeService.getSystemDeviceTypes();

    if (this.$route.params.id !== 'new') {
      if (!(await this.returnDataSetAsync(this.$route.params.id))) {
        return;
      }
      const dataSet = this.getDataSetById(this.$route.params.id);

      if (!dataSet) {
        try {
          const dataset = await DataSetService.getDataSetById(Number(this.$route.params.id));
          this.dataSet = dataset;
          this.selections = dataset.filters;
          this.useInterfaces = this.selections.hasOwnProperty('interfaces');
          this.isSystem = dataset.owner === 'system';
        } catch (e) {
          this.dataSet = {} as DataSet;
        }
      } else {
        this.dataSet = dataSet;
        this.selections = JSON.parse(dataSet.filters);
        this.useInterfaces = this.selections.hasOwnProperty('interfaces');
        this.isSystem = dataSet.owner === 'system';
      }
      for (const type in this.selectedEmpty) {
        if (this.selectedEmpty.hasOwnProperty(type)) {
          this.selectedEmpty[type] = !this.selections[type];
        }
      }

      const base = { projects: [], sites: [], deviceTypes: [], interfaces: [] };
      this.selections = { ...base, ...this.selections };
    } else {
      for (const type in this.selectedEmpty) {
        if (this.selectedEmpty.hasOwnProperty(type)) {
          this.selectEmpty(type);
        }
      }
    }
    const projResp = await ProjectService.getProjects(0, 0, '', false, undefined, '');

    Vue.set(this, 'projects', projResp.projects);

    const { sites } = await SiteService.getSites(0, 0, '', false, undefined, null, '');
    Vue.set(this, 'sites', sites);

    this.getProjects();
    this.getSites();
    this.getDeviceTypes();

    this.onSelectionChange();
  }

  private itemValue(item: any): number | string {
    return this.currentTab === 'interfaces' ? item.slug : item.id;
  }

  private isSelected(item: any): boolean {
    const arr = this.selections[this.currentTab];
    return Array.isArray(arr) && arr.includes(this.itemValue(item));
  }

  private toggleSelection(item: any) {
    if (this.disabledCheckboxes) { return; }
    const type = this.currentTab;
    const val = this.itemValue(item);
    const current = Array.isArray(this.selections[type]) ? this.selections[type] : [];
    const next = current.includes(val)
        ? current.filter((v: any) => v !== val)
        : [...current, val];
    this.selections = { ...this.selections, [type]: next };  // replace, don't mutate
  }

  private get total() {
    return this.tabContents[this.currentTab].length;
  }

  private get selected() {
    if (this.selections[this.currentTab]) {
      return this.selections[this.currentTab].length;
    }
  }

  private get disabledCheckboxes() {
    return this.selectedEmpty[this.currentTab];
  }

  private getOwnerDetails(field: string) {
    if (!this.login || !this.login.details) {
      return '-';
    }
    if (field === 'name') {
      return `${this.login.details.first_name} ${this.login.details.last_name}`;
    }
    if (field === 'email') {
      return `${this.login.details.email}`;
    }
  }

  @Watch('selections', {deep: true, immediate: false})
  private onSelectionChange() {

    if (this.selections.projects && !this.selections.projects.length) {
      this.getSites();
    }
    this.updateTabs();

  }

  private selectAll(list: any, type: string) {
    if (this.selectedAll[type] > 0 || this.selectedAll[type] === undefined) {
      for (const row of list) {
        if (this.selections[type] && this.selections[type].indexOf(row.id) === -1) {
          this.selections[type].push(row.id);
        }
      }
    } else {
      this.selections[type] = [];
    }
  }

  private get currentTab() {
    switch (this.tab) {
      case 0:
        return this.tabs[0].type;
      case 1:
        return this.tabs[1].type;
      case 2:
        return this.tabs[2].type;
      case null:
        return this.tabs[0].type;
      default:
        return this.tabs[0].type;
    }
  }

  private async getProjects() {
    Vue.set(this.tabContents, 'projects', this.projects);
  }

  private async getSites() {
    Vue.set(this.tabContents, 'sites', this.sites);
  }

  private async getDeviceTypes() {
    const deviceTypes = await DeviceTypeService.getCatalogue();

    Vue.set(this, 'deviceTypes', deviceTypes);
    Vue.set(this.tabContents, 'deviceTypes', this.deviceTypes);

    this.deviceTypes.forEach((dt: any) => {
      if (!(dt.interfaces && dt.interfaces.length > 0)) {
        return;
      }

      dt.interfaces.forEach((i: any) => {
        if (!this.interfaces.find((j: any) => j.id === i.interface.id)) {
          this.interfaces.push(i.interface);
        }
      });
    });

    this.tabContents.interfaces = this.interfaces;
  }

  private get searchedList() {
    return this.tabContents[this.currentTab].filter((item: any) => {
      if (this.search) {
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      } else {
        return item;
      }
    });
  }

  private clearSearch() {
    this.search = '';
  }

  private updateTabs() {
    const sites: Site[] = [];
    if (Object.keys(this.selections).length > 0) {
      if (this.selections.projects && this.selections.projects.length) {
        for (const project of this.selections.projects) {
          if (this.projects.length) {
            const currentProject = this.projects.find((p: Project) => p.id === project);
            if (currentProject) {
              this.sites.map((site: Site) => {
                if (currentProject.id === site.project_id) {
                  sites.push(site);
                }
              });
            }
            Vue.set(this.tabContents, 'sites', sites);
          }
        }
      }
      if (this.tabContents.sites.length) {
        if (this.selections.sites && this.selections.sites.length) {
          const newSites: number[] = [];
          for (const site of this.selections.sites) {
            const res = this.tabContents.sites.find((s: Site) => s.id === site);
            if (res) {
              newSites.push(site);
            }
          }
          if (this.selections.sites.length !== newSites.length) {
            Vue.set(this.selections, 'sites', newSites);
          }
        }
      }
    }
  }

  private async save() {
    if (this.disableSave) {
      return;
    }
    const selections: any = {
      projects: this.selectedEmpty.projects ? null : this.selections.projects,
      sites: this.selectedEmpty.sites ? null : this.selections.sites,
    };

    if (this.useInterfaces) {
      selections.interfaces = this.selectedEmpty.interfaces ? null : this.selections.interfaces;
    } else {
      selections.deviceTypes = this.selectedEmpty.deviceTypes ? null : this.selections.deviceTypes;
    }

    let payload: DataSet = {
      name: this.dataSet.name,
      filters: JSON.stringify(  selections),
      streaming: false,
      publishing: false,
      query: false,
      owner: this.isSystem ? 'system' : ( this.getOwnerDetails('name') ? this.getOwnerDetails('name') : this.getOwnerDetails('email')) as string,
    };

    if (this.dataSet.id) {
      payload = {
        ...payload,
        streaming: this.dataSet.streaming,
        publishing: this.dataSet.publishing,
        query: this.dataSet.query,
        owner: this.isSystem ? 'system' : this.dataSet.owner,
      };
      await DataSetService.updateDataSet(this.dataSet.id, payload);
    } else {
      await DataSetService.createDataSet(payload);
    }
    this.$router.push({name: 'datasets', params: {snackbar: true}} as any);
  }

  private goBack() {
    this.$router.push({name: 'datasets'});
  }

  private selectEmpty(type: string) {
    this.selections = { ...this.selections, [type]: [] };
  }

  private get nameRules() {
    return [
      (v: string) => !!v || 'Event name is required',
    ];
  }

  private get requiredSections(): string[] {
    return ['projects', 'sites', this.useInterfaces ? 'interfaces' : 'deviceTypes'];
  }

  private get emptyRequiredSections(): string[] {
    return this.requiredSections.filter((type) =>
        !this.selectedEmpty[type] && !(this.selections[type] && this.selections[type].length),
    );
  }

  private get disableSave(): boolean {
    return !this.dataSet.name || this.emptyRequiredSections.length > 0;
  }

  private get tabs(): any[] {
    return this.items.filter((item) => {
      if (item.type === 'deviceTypes' && this.useInterfaces) {
        return false;
      }

      if (item.type === 'interfaces' && !this.useInterfaces) {
        return false;
      }

      return true;
    });
  }

  private handleUseInterfacesClick() {
    const value = this.useInterfaces;
    if (value && (!this.selections.interfaces || this.selections.interfaces.length === 0)) {
      this.selectedEmpty.interfaces = true;
    } else if (!value && (!this.selections.deviceTypes || this.selections.deviceTypes.length === 0)) {
      this.selectedEmpty.deviceTypes = true;
    }

    // avoids tab-switching enforced by Vuetify
    if (this.tab === 2) {
      setTimeout(() => this.tab = 2, 10);
    }
  }
}

